import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import slugify from "slugify";

import { Skeleton } from "@mui/material";
import formattedDate from "@/utils/formattedDate";
import { RootState } from "@/store/store";
import { setPatientId } from "@/store/patients/patients";
import { setIsVisibleModalDialog } from "@/store/ui/ui";

import { PatientsListProps } from "@/shared/interfaces/patientPage";

import "./UsersListing.scss";

export default function UsersListing({ isLoading }: PatientsListProps) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.data.data);
    const dataLength = useSelector((state: RootState) => state.data.dataLength);

    const handleDelete = (id: string) => {
        dispatch(setPatientId(id));
        dispatch(setIsVisibleModalDialog(true));
    };

    return (
        <section className='appoints_main_content patients_listing_container'>
            <table className='listing_table'>
                <thead>
                    <tr>
                        <th>ПІБ лікаря</th>
                        <th>Електронна пошта</th>
                        <th>Посада</th>
                        <th>Дата додавання</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading
                        ? Array.from({ length: dataLength }).map((_, index) => (
                              <tr key={index}>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          height={34}
                                          style={{
                                              padding: 8,
                                              margin: "auto",
                                          }}
                                      />
                                  </td>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          height={34}
                                          style={{
                                              padding: 8,
                                              maxWidth: "93%",
                                              margin: "auto",
                                          }}
                                      />
                                  </td>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          height={34}
                                          style={{
                                              padding: 8,
                                              maxWidth: "74%",
                                              margin: "auto",
                                          }}
                                      />
                                  </td>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          width={"100%"}
                                          height={34}
                                          style={{ padding: 8 }}
                                      />
                                  </td>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          height={34}
                                          style={{
                                              padding: 8,
                                              margin: "auto",
                                          }}
                                      />
                                  </td>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          height={34}
                                          style={{
                                              padding: 8,
                                              margin: "auto",
                                          }}
                                      />
                                  </td>
                              </tr>
                          ))
                        : data &&
                          data.map(doctor => (
                              <tr key={doctor._id}>
                                  <td
                                      className='users_page_td'
                                      id={doctor._id}
                                      onClick={() =>
                                          navigate(`/users/${doctor._id}`)
                                      }
                                  >
                                      {doctor.name}
                                  </td>
                                  <td className='users_page_td'>
                                      {doctor.email}
                                  </td>
                                  <td className='users_page_td'>
                                      {doctor.roleInClinic === "doctor"
                                          ? "Лікар"
                                          : "Адміністратор"}
                                  </td>
                                  <td className='users_page_td'>
                                      {doctor.createdAt
                                          ? formattedDate(doctor.createdAt)
                                          : ""}
                                  </td>
                                  <td>
                                      <button
                                          className='listing_icons'
                                          id={doctor._id}
                                          onClick={e =>
                                              handleDelete(e.currentTarget.id)
                                          }
                                      >
                                          <img
                                              src='/patients/delete.svg'
                                              alt='edit-logo'
                                              id={doctor._id}
                                          />
                                      </button>
                                  </td>
                              </tr>
                          ))}
                </tbody>
            </table>
        </section>
    );
}
